'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trim2 = require('lodash/trim');

var _trim3 = _interopRequireDefault(_trim2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _constants = require('../../../constants');

var _commonFormsy = require('../../common-formsy');

var _SmartBool = require('../../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _utils = require('../../../utils');

var _GroupedSearchResultsMenu = require('./results/GroupedSearchResultsMenu');

var _GroupedSearchResultsMenu2 = _interopRequireDefault(_GroupedSearchResultsMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEBOUNCE_DELAY = _constants.AppConstants.DEBOUNCE_DELAY,
    DEFAULT_TRUNCATION_LENGTH = _constants.AppConstants.DEFAULT_TRUNCATION_LENGTH,
    MIN_SEARCH_QUERY_LENGTH = _constants.AppConstants.MIN_SEARCH_QUERY_LENGTH,
    USER_FLOW = _constants.AppConstants.USER_FLOW;
var truncate = _utils.FormattingUtils.truncate;
var SearchBar = (_dec = (0, _mobxReact.inject)('Clients', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar(props) {
    _classCallCheck(this, SearchBar);

    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

    _initDefineProp(_this, 'isLoadingSearchResults', _descriptor, _this);

    _initDefineProp(_this, 'value', _descriptor2, _this);

    _initDefineProp(_this, 'searchResults', _descriptor3, _this);

    _initDefineProp(_this, 'lastRequestTimestamp', _descriptor4, _this);

    _this.debouncedOnSearch = (0, _debounce3.default)(_this.onSearchInputChange, DEBOUNCE_DELAY);
    return _this;
  }

  _createClass(SearchBar, [{
    key: 'onSearchResultSelect',
    value: function onSearchResultSelect(result) {
      var SessionStore = this.props.SessionStore;


      if (!result) {
        return;
      }

      if ((0, _isEmpty3.default)(result._search_report)) {
        // istanbul ignore next
        throw new Error('Search report not available');
      }
      SessionStore.trackEvent('SEARCH_RESULT_SELECTED', result._search_report);
      _reactRouter.browserHistory.push(Object.assign(result.path, { state: USER_FLOW.FROM_SEARCH_BAR }));
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.debouncedOnSearch.cancel();

      if (this.abortController) {
        this.abortController.abort();
      }
      this.lastRequestTimestamp = null;
      this.isLoadingSearchResults.setFalse();
      this.value = null;
      this.searchResults = [];
    }
  }, {
    key: 'onSearchInputChange',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var isMightyFreeUser, query, requestTimestamp, signal, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isMightyFreeUser = this.props.SessionStore.isMightyFreeUser, query = (0, _trim3.default)(value);
                // Trim once here, so the length gate and the request agree on what the query is.

                if (!(query.length < MIN_SEARCH_QUERY_LENGTH)) {
                  _context.next = 4;
                  break;
                }

                this.clearSearch();
                return _context.abrupt('return');

              case 4:
                if (!(query !== this.value)) {
                  _context.next = 27;
                  break;
                }

                this.value = truncate(query, DEFAULT_TRUNCATION_LENGTH);
                requestTimestamp = new Date().getTime();

                // Check if there's an ongoing request and cancel it

                if (this.abortController) {
                  this.abortController.abort();
                  this.isLoadingSearchResults.setFalse();
                }

                // Create a new AbortController for the current request
                this.abortController = new AbortController();
                signal = this.abortController.signal;


                this.isLoadingSearchResults.setTrue();

                _context.prev = 11;

                this.lastRequestTimestamp = requestTimestamp;
                _context.next = 15;
                return this.client.list({ params: _defineProperty({}, this.searchQueryParam, query), signal: signal });

              case 15:
                response = _context.sent;


                // only update the results if the response timestamp matches the most recent request
                if (this.lastRequestTimestamp === requestTimestamp) {
                  this.searchResults = isMightyFreeUser ? this.searchResults.results : response;
                }
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](11);

                if (!(_context.t0.name === 'AbortError')) {
                  _context.next = 24;
                  break;
                }

                // eslint-disable-next-line no-console
                console.log('Request canceled.');
                return _context.abrupt('return');

              case 24:
                _context.prev = 24;

                // An aborted request settles after the one that replaced it started loading, so only
                // the request still current is allowed to put the spinner away.
                if (this.lastRequestTimestamp === requestTimestamp) {
                  this.isLoadingSearchResults.setFalse();
                }
                return _context.finish(24);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 19, 24, 27]]);
      }));

      function onSearchInputChange(_x) {
        return _ref.apply(this, arguments);
      }

      return onSearchInputChange;
    }()
  }, {
    key: 'renderMenu',
    value: function renderMenu(results, props) {
      if (!this.value) {
        return _react2.default.createElement('div', null);
      }
      return _react2.default.createElement(_GroupedSearchResultsMenu2.default, {
        isLoading: this.isLoadingSearchResults.isTrue,
        results: results,
        searchValue: this.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this.isLoadingSearchResults.isTrue ? [] : (0, _mobx.toJS)(this.searchResults);

      return _react2.default.createElement(
        _commonFormsy.Form,
        { className: 'app-searchbar' },
        _react2.default.createElement(_commonFormsy.Typeahead, {
          className: 'fs-mask',
          fuzzySearch: true,
          name: 'search-bar',
          onChange: this.onSearchResultSelect,
          onClear: this.clearSearch,
          onInputChange: this.debouncedOnSearch,
          options: options,
          placeholder: 'Search...',
          renderMenu: this.renderMenu,
          search: true
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'client',
    get: function get() {
      var _props = this.props,
          Clients = _props.Clients,
          SessionStore = _props.SessionStore;


      if (SessionStore.isMightyFreeUser) {
        return Clients.caseSearch;
      }

      return Clients.search;
    }
  }, {
    key: 'searchQueryParam',
    get: function get() {
      var isMightyFreeUser = this.props.SessionStore.isMightyFreeUser;


      return isMightyFreeUser ? 'search' : 'q';
    }

    // Clears the search, so a shortened query does not leave the previous query's results on screen.
    // An in-flight request has to be invalidated too, or its response repopulates them.

  }]);

  return SearchBar;
}(_react.Component), _class3.propTypes = {
  Clients: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoadingSearchResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default(false);
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'searchResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'lastRequestTimestamp', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'clearSearch', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'clearSearch'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSearchInputChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onSearchInputChange'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = SearchBar;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEBOUNCE_DELAY, 'DEBOUNCE_DELAY', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(DEFAULT_TRUNCATION_LENGTH, 'DEFAULT_TRUNCATION_LENGTH', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(MIN_SEARCH_QUERY_LENGTH, 'MIN_SEARCH_QUERY_LENGTH', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(truncate, 'truncate', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(SearchBar, 'SearchBar', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/search/SearchBar.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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